import { ComponentIds } from '@inter-ikea-core/core';
import { CoreApi, Product, ProductType } from '@inter-ikea-storageone/range';
import { changeAllDrawersOpeningFunction } from 'rangeConfig/shared/utils/frontLayouts';

export const changeToSoftClosingFunctionAndAddHandles = (
  coreProductId: string,
  coreApi: CoreApi,
  products: Product[]
) => {
  const handleProduct = products.find(p => p.coreProductId === coreProductId);
  if (!handleProduct) return;
  coreApi.history.historyAction(() => {
    changeAllDrawersOpeningFunction(ProductType.BESTA_SOFT_CLOSING, products, coreApi, false);
    const handlesInScene = coreApi.entities.getByComponent(ComponentIds.HANDLE_COMPONENT_ID);
    const fronts = coreApi.entities.getByComponents([
      ComponentIds.DOOR_COMPONENT_ID,
      ComponentIds.DRAWER_COMPONENT_ID
    ]);
    coreApi.products.autoFillHandles(coreProductId, handlesInScene, fronts);
  });
};

export const changeToPushOpenFunctionAndRemoveHandles = (coreApi: CoreApi, products: Product[]) => {
  coreApi.history.historyAction(() => {
    changeAllDrawersOpeningFunction(ProductType.BESTA_PUSH_OPEN, products, coreApi, false);
    const handlesInScene = coreApi.entities.getByComponent(ComponentIds.HANDLE_COMPONENT_ID);
    handlesInScene.forEach(handle => {
      coreApi.entities.delete(handle);
    });
  });
};
